import * as React from "react";

import {
  Box,
  Slide,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FileName({ open, handleClose }) {
  const { t } = useTranslation("common");
  const [name, setName] = React.useState("");

  return (
    <Box color="default">
      <Dialog
        open={open !== null ? true : false}
        onBackdropClick={() => handleClose(false)}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,
            padding: 16,
            width: "300px",
          },
        }}
      >
        <DialogContent sx={{ padding: 0 }}>
          <OutlinedInput
            sx={{ width: "100%" }}
            placeholder={t("fileName")}
            onChange={(e) => setName(e.target.value)}
          />
          {name.length > 100 ? (
            <Typography className="fs-12 error">{t("tooLong")}</Typography>
          ) : null}
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            variant="contained"
            color="primary"
            onClick={() => handleClose(true, open, name)}
            disabled={!name || name.length > 100}
          >
            {t("addPopup.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
